import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const textLine = () => {

	const isBlockEditor =
		document.body?.classList.contains("wp-admin") ||
		document.body?.classList.contains("block-editor-iframe__body") ||
		document.documentElement.classList.contains("block-editor-iframe__html");

	if (isBlockEditor) return;

	const blocks = document.querySelectorAll(".text-line");

	if (!blocks.length) return;

	const mm = gsap.matchMedia();

	mm.add("(min-width: 992px)", () => {

		createAnimations(getScroller());

	});

	mm.add("(max-width: 991px)", () => {

		createAnimations();

	});

};

function getScroller() {
	const isHome = document.body.classList.contains("home");
	const isDesktop = window.innerWidth >= 992;

	return (isHome && isDesktop) ? ".wp-site-blocks" : undefined;
}

function createAnimations(scroller) {

	const blocks = document.querySelectorAll(".text-line");

	blocks.forEach((block) => {

		const isHomeHero =
			document.body.classList.contains("home") &&
			block.closest("#inicio");

		if (isHomeHero) {
			gsap.fromTo(block,
				{
					"--lineScale": 0
				},
				{
					"--lineScale": 1,
					duration: 1,
					ease: "power2.out",
					onComplete: () => {
						block.style.setProperty("--lineScale", "1");
					}
				}
			);

			return;
		}

		gsap.fromTo(block,
			{
				"--lineScale": 0
			},
			{
				"--lineScale": 1,
				ease: "none",
				scrollTrigger: {
					trigger: block,
					scroller,
					start: "top 85%",
					end: "top 60%",
					scrub: true
				}
			}
		);

	});

	ScrollTrigger.refresh();

}
